/**
 *
 * AccessDenied
 *
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';

// styles
import './style.scss';

import useDeviceDetect from 'utils/useDeviceDetect';
import history from 'utils/history';

// antd component
import { Layout, Button } from 'antd';
const { Content } = Layout;

function AccessDenied({
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('access-denied-wrapper', "main-full-content", isMobile && 'is-mobile', className);
  const { isMobile } = useDeviceDetect();

  return (
    <Layout className={childClassNames}>
      <Helmet>
        <title>403</title>
        <meta name="description" content="Access Denied - 403" />
      </Helmet>
      <Content className="main-content-container">
        <div className="container-wrapped">

          <div className={classNames(isMobile && 'is-mobile', "access-denied")}>
            <div className="access-denied__numbers">
              <span>4</span>
              <span><span className="screen-reader-text">0</span></span>
              <span>3</span>
            </div>
            <Button
              onClick={() => history.push('/home')}
              type="default"
              className="access-denied__button">
              Home
            </Button>
          </div>

        </div>
      </Content>
    </Layout>
  );
}

AccessDenied.defaultProps = {};
AccessDenied.propTypes = {};

export default AccessDenied;
